export interface MarketingPreferences {
  post?: boolean;
  email?: boolean;
  telephone?: boolean;
  phone?: boolean;
}
